import React, { FunctionComponent } from "react";
import styles from "./Entrances.module.scss";
import EntrancesBlockProps from "./EntrancesProps.interface";

import combineClasses from "helpers/combine-classes";
import Entrance from "./components/Entrance/Entrance";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import useAnchor from "blocks/hooks/useAnchor";

const Entrances: FunctionComponent<EntrancesBlockProps> = (props): JSX.Element => {
    const bannerSizeClass = props.settings.bannerSize ? styles[`size_${props.settings.bannerSize}`] : styles.size_Medium;
    const imageAspectRatio = getImageAspectRatio(undefined, props.content.image?.umbracoWidth, props.content.image?.umbracoHeight);

    const identifier = useAnchor(props.settings.anchorMenuLabel);

    const imagePositionClass = props.content.imagePosition ? styles[`position_${props.content.imagePosition}`] : undefined;

    return (
        <section className={combineClasses(styles.wrapper, bannerSizeClass)} id={identifier}>
            {props.content?.entrances?.map((entrance, index) => {
                return (
                    <Entrance key={index} {...entrance} />
                );
            })}

            {props.content.image ? (
                <div className={combineClasses(styles.media, imagePositionClass)}>
                    <ImageViewer className={styles.image} src={props.content.image.umbracoFile.src} extensionType="png" type="contain" aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                </div>
            ) : null}
        </section>
    );
};

export default Entrances;